import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const JSON_HEADERS = { "Content-Type": "application/json" };

export const login = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/api-token-auth`, payload, {
        headers: JSON_HEADERS,
    })

export const register = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/users/`, payload, {
        headers: JSON_HEADERS,
    })

export const verificationOtp = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/activate-account`, payload, {
        headers: JSON_HEADERS,
    })

export const forgotPassword = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/password-reset`, payload, {
        headers: JSON_HEADERS,
    })

export const resetPassword = async (payload: any) =>
    await axios.post(`${API_URL}/recouv/password-reset-confirm`, payload, {
        headers: JSON_HEADERS,
    })
